import { NavLink } from "react-router-dom";
import { Scan, Compass, Sparkle, Clock, User } from "lucide-react";

const items = [
  { to: "/scan",     label: "Scan",     Icon: Scan,    testid: "nav-home-tab" },
  { to: "/discover", label: "Discover", Icon: Compass, testid: "nav-discover-tab" },
  { to: "/mystery",  label: "Mystery",  Icon: Sparkle, testid: "nav-mystery-tab" },
  { to: "/history",  label: "History",  Icon: Clock,   testid: "nav-history-tab" },
  { to: "/profile",  label: "Profile",  Icon: User,    testid: "nav-profile-tab" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md px-3 pb-3 pt-2 z-40"
    >
      <div className="jx-glass rounded-3xl h-16 flex items-center justify-around px-2">
        {items.map(({ to, label, Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-2xl transition-all active:scale-95 ${
                isActive ? "text-cyan-300" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`p-1.5 rounded-xl ${isActive ? "bg-cyan-400/10 shadow-[0_0_18px_rgba(0,229,255,0.35)]" : ""}`}>
                  <Icon size={20} strokeWidth={2.2} />
                </div>
                <span className="text-[10px] font-mono-data uppercase tracking-wider">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
